import { useRef } from 'react'

export default function Vote() {


    const baseUrl = "https://gtop100.com/topsites/MapleStory/sitedetails/------------MapleLand-8x------4x----------------------------------------101331?vote=1&pingUsername=";
    const usernameInputRef = useRef(null);

    function vote() {
        // console.log(username);
        window.open(baseUrl + usernameInputRef.current.value);
    }

    const handleKeypress = e => {
        //it triggers by pressing the enter key
        if (e.charCode === 13) {
            vote()
        }
    };

    return (
        <div className="vote">
            <input className='username-input' type="text" placeholder='用户名'
                ref={usernameInputRef}
                onKeyPress={handleKeypress}
            />

            <button onClick={() => vote()}>
                投票
            </button>
            <p className="vote-hint">
                投票成功后自动兑换8000点券（5分钟内到账）
            </p>
        </div>
    );
}